import { useState } from 'react'

import { useTranslation } from 'react-i18next'

import styles from './textArea.module.scss'

interface Props {
    id: string
    value: string
    changeFn: (val: string) => void
    customClass?: string
    maxChar?: number
    showCount?: boolean
    placeholder?: string
    label?: string
    name?: string
    rows?: number
    cols?: number
    shouldRemoveLabelOnFocus?: boolean
}

const TextArea = ({
    id,
    value,
    placeholder,
    changeFn,
    showCount,
    maxChar,
    name,
    rows,
    cols,
    label,
    shouldRemoveLabelOnFocus = false
}: Props) => {
    const [focus, setFocus] = useState(false)
    const { t } = useTranslation()
    return (
        <div
            className={`${styles.wrapper} ${
                !shouldRemoveLabelOnFocus && (value || focus)
                    ? styles.active
                    : ''
            }`}
        >
            {!shouldRemoveLabelOnFocus && (value || focus) && (
                <label htmlFor={id}>{label}</label>
            )}
            <textarea
                value={value}
                id={id}
                placeholder={placeholder}
                maxLength={maxChar}
                name={name ?? id}
                cols={cols}
                rows={rows}
                onChange={e => {
                    changeFn(e.target.value)
                }}
                onFocus={() =>
                    !focus && !shouldRemoveLabelOnFocus && setFocus(true)
                }
                onBlur={() =>
                    focus && !shouldRemoveLabelOnFocus && setFocus(false)
                }
            />
            {showCount && !!maxChar && (
                <div className={styles.count}>
                    <p>
                        <span>{value.length}</span> / {maxChar}
                    </p>
                    <p> {t('characters')}</p>
                </div>
            )}
        </div>
    )
}

export default TextArea
